import { Skeleton } from '@/components/ui/skeleton'

/**
 * Results-panel skeleton shown while isCalculating=true.
 *
 * Shape matches the real results (CostSummary → ElevationChart →
 * StateBreakdown) so the layout doesn't jump when real data arrives.
 * Heights are approximate averages from instrumented production data —
 * close enough that the content-ready state lands in the same visual
 * region and feels continuous rather than a flash.
 *
 * This is aria-hidden: the visible "Calculating..." button already has
 * a live region that announces status. The skeleton is purely visual
 * reassurance that results will appear here.
 */
export function CalculationSkeleton() {
	return (
		<output aria-label="Calculating fuel estimate" aria-busy="true" className="block space-y-4">
			{/* Hero stat */}
			<div className="space-y-2 text-center">
				<Skeleton className="mx-auto h-3 w-24" />
				<Skeleton className="mx-auto h-9 w-40" />
				<Skeleton className="mx-auto h-3 w-36" />
			</div>

			{/* Secondary stats — 4-up inline row */}
			<div className="flex flex-wrap justify-center gap-x-5 gap-y-2">
				{[0, 1, 2, 3].map((i) => (
					<div key={i} className="space-y-1 text-center">
						<Skeleton className="mx-auto h-4 w-14" />
						<Skeleton className="mx-auto h-2.5 w-12" />
					</div>
				))}
			</div>

			{/* Meta row */}
			<Skeleton className="mx-auto h-3 w-48" />

			{/* Elevation chart */}
			<div className="space-y-2">
				<Skeleton className="h-3 w-28" />
				<Skeleton className="h-24 w-full" />
			</div>

			{/* State breakdown — 3 placeholder rows */}
			<div className="space-y-2">
				<Skeleton className="h-3 w-32" />
				{[0, 1, 2].map((i) => (
					<div key={i} className="flex items-center gap-2">
						<Skeleton className="size-8 rounded" />
						<div className="flex-1 space-y-1">
							<Skeleton className="h-3 w-1/2" />
							<Skeleton className="h-2 w-1/3" />
						</div>
						<Skeleton className="h-4 w-14" />
					</div>
				))}
			</div>
		</output>
	)
}
